import React, { useContext } from "react"
import { GENRES } from "src/models/common"
import { Divider, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { UserContext } from "src/providers"
import { MultilangJob, stripCategoryPrefix } from "src/services/api/document"
import { CardColor } from "src/components/browser/card/BrowserCard"
import { useResponsive } from "src/utils/useResponsive"
import { LanguagesRow } from "./LanguagesRow"
import { WordCountsRow } from "./WordCountsRow"

interface MoreInfoProps {
  multilangJob: MultilangJob
  open: boolean
  color: CardColor
}

export const MoreInfo = ({ multilangJob, open, color }: MoreInfoProps) => {
  const { t } = useTranslation("multilang")
  const { isMobile } = useResponsive()
  const genre = GENRES.find((g) => multilangJob.genre === g.id)?.genre || multilangJob.genre

  return open ? (
    <>
      <Divider />
      <Table>
        <TableBody>
          <LanguagesRow color={color} multilangJob={multilangJob} />
          <WordCountsRow multilangJob={multilangJob} />
          {!isMobile && (
            <>
              <MoreInfoRow propName={t("genre")} value={genre} />
              <MoreInfoRow
                propName={t("skillset")}
                value={multilangJob.taxonomy.map((t) => stripCategoryPrefix(t)).join(", ")}
              />
              <GatedCommunityRow communityIds={multilangJob.gatedCommunityIds} />
            </>
          )}
        </TableBody>
      </Table>
    </>
  ) : (
    <></>
  )
}

const GatedCommunityRow = ({ communityIds }: { communityIds: string[] }) => {
  const { userCommunities } = useContext(UserContext)
  const { t } = useTranslation("multilang")
  const jobCommunityNames = communityIds.map(
    (gc) => userCommunities?.find((c) => c.gatedCommunityId === gc)?.gatedCommunityName
  )
  return <MoreInfoRow propName={t("communities")} value={jobCommunityNames.join(", ")} />
}

const MoreInfoRow = ({ propName, value }: { propName: string; value: string }) => (
  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
    <TableCell width={"150px"}>{propName}</TableCell>
    <TableCell>
      <Typography variant="h6">{value}</Typography>
    </TableCell>
  </TableRow>
)
